import { action, makeObservable, observable, reaction } from 'mobx';
import { UiStore } from './ui';
import { appConfig } from '../settings';
import { IFilterParams, IPaperTrailLogsItem } from '../interfaces';
import { getPaperTrailLogsList } from '../middleware';
import { apiParamsCleaner } from '../instruments';

export class PaperTrailLogStore {
    private constructor() {
        makeObservable(this);
        reaction(
            () => this.forcedUpdateTime,
            () => {
                const UiStoreInstance = UiStore.getInstance();
                const params = UiStoreInstance.params;
                const cleanParams = apiParamsCleaner(params, this.filterParams);
                getPaperTrailLogsList(cleanParams).then();
            },
            {
                delay: appConfig.APIDelay,
            },
        );
    }

    private static instance: PaperTrailLogStore;
    public static getInstance(): PaperTrailLogStore {
        if (!PaperTrailLogStore.instance) {
            PaperTrailLogStore.instance = new PaperTrailLogStore();
        }
        return PaperTrailLogStore.instance;
    }

    @observable list: IPaperTrailLogsItem[] = [];
    @action setPaperTrailLogsList(paperTrailLogsList: IPaperTrailLogsItem[]): void {
        this.list = paperTrailLogsList;
    }

    @observable forcedUpdateTime = 0;
    @action setForcedUpdateTime(): void {
        this.forcedUpdateTime = Date.now();
    }

    @observable filterParams: IFilterParams = {
        companyId: true,
        userId: true,
        pageNumber: true,
        pageSize: true,
        search: true,
    };

    @action cleanStore(): void {
        this.list = [];
    }
}
